import Api from '.';
import { endpoints } from './endpoints';

export default class EmandateApi extends Api {

    emandate(data) {
        let url = this.buildUrl(endpoints.emandate.emandate)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    confirmEmandate(data) {
        let url = this.buildUrl(endpoints.emandate.confirmEmandate)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    razorpayStatus(data) {
        let url = this.buildUrl(endpoints.emandate.razorpayStatus)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

}